<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="Rol_detay">
        <AppMain>





            <div class="nk-content ">
        <div class="container-fluid">
            <div class="nk-content-inner">
                <div class="nk-content-body">
                    <div class="nk-block-head nk-block-head-sm">
                        <div class="nk-block-between g-3">
                            <div class="nk-block-head-content">

                            

                                <h3 class="nk-block-title page-title">Rol  / <strong class="text-primary small">{{ roller.ad }}</strong></h3>
                                <div class="nk-block-des text-soft">
                                    <ul class="list-inline">
                                        <li>Rol  ID: <span class="text-base">{{ roller.id }}</span></li>
                                        <li>Güncelleme Tarihi: <span class="text-base">{{ roller.duzenleme_tarih }}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="nk-block-head-content">
                                <router-link to="/roller"  class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                        class="icon ni ni-arrow-left"></em><span>Roller</span>
                                    </router-link>
                                  </div>
                        </div>
                    </div>
                    <div class="nk-block">
                        <div class="card card-bordered">
                            <div class="card-aside-wrap">
                                <div class="card-content">
                                    <ul class="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                                        
                                        <li class="nav-item">
                                            <a  href="#" :class="{ 'active': aktifSekme === 'bilgiler','nav-link':true}"
                                            @click="aktifSekmeDegistir('bilgiler')">
                                                <em class="icon ni ni-user-circle"></em>
                                                <span>Rol Bilgileri</span>
                                            </a>
                                        </li>

                                        

                                        
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'kullanicilar','nav-link':true}"
                                                    @click="aktifSekmeDegistir('kullanicilar')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Kullanıcılar</span>
                                                    </a>
                                                </li>
                                    


                                        
                                   
                                        

                                     
                                        
                                     
                                        <li class="nav-item nav-item-trigger d-xxl-none">
                                            <a href="#" class="toggle btn btn-icon btn-trigger" data-target="userAside">
                                            <em class="icon ni ni-user-list-fill"></em></a>
                                        </li>
                                    </ul>

                               
                                    <div class="card-inner" v-show="aktifSekme === 'bilgiler'">
                                        <div class="nk-block">
                                            <div class="nk-block-head">
                                                <h5 class="title">Rol Bilgileri</h5>
                                               
                                            </div>
                                            <div class="profile-ud-list">
                                                


                                                
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ad </span><span class="profile-ud-value">{{ roller.ad }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Açıklama </span><span class="profile-ud-value">{{ roller.aciklama }}</span></div>
                                                                </div>
                                    
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">yetkiler </span><span class="profile-ud-value">{{ roller.yetkiler }}</span></div>
                                                                </div>
                                    

                                    
                                                 
                                                    

                                            </div>
                                        </div>
                                        <div class="nk-block">
                                            <div class="nk-block-head nk-block-head-line">
                                                <h6 class="title overline-title text-base">Kayıt Bilgileri</h6>
                                            </div>
                                            <div class="profile-ud-list">
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Oluşturma Tarihi</span><span class="profile-ud-value">{{ roller.olusturma_tarih }}</span></div>
                                                </div>
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Son Düzenleme Tarihi</span><span class="profile-ud-value">{{ roller.duzenleme_tarih }}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="nk-divider divider md"></div>
                                      
                                    </div>
                                    

                                    
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'kullanicilar'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Kullanıcılar</h6>
                                                    <a  @click="kullanicilar_ekle" class="btn btn-primary" >
                                                        <span>Kullanıcı Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <kullaniciCard :kullanicilar="kullanicilar" :duzenle="kullanicilar_duzenle"  :detay="kullanicilar_duzenle"  :formKaydetSonrasi="rollerDetayGetir"  @update:kullanicilar="kullanicilarGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="kullanicilar.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="kullanicilar.islem == 'ekle'"> Yeni Kullanıcı Ekle </h5>
                                                    <h5 class="modal-title" v-if="kullanicilar.islem == 'duzenle'">Kullanıcı Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="kullanicilar_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <kullaniciForm :formIslem="kullanicilar.islem" :formData="kullanicilar.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="kullanicilar_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                          
                             
                                      



                                </div>
                                <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl toggle-screen-xxl"
                                    data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true"
                                    data-toggle-body="true">
                                    <div class="card-inner-group" data-simplebar="init">
                                        <div class="simplebar-wrapper" style="margin: 0px;">
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask">
                                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                                        aria-label="scrollable content"
                                                        style="height: auto; overflow: hidden;">
                                                        <div class="simplebar-content" style="padding: 0px;">
                                                            <div class="card-inner">
                                                                <div class="user-card user-card-s2">
                                                                    <div class="user-avatar lg bg-primary"> 
                                                                         <img :src="$globalVariable.uploadUrl + roller.logo"
                                                                            @error="$globalVariable.varsayilanGorsel" class="img-fluid rounded-xl">
                                                                        </div>
                                                                    <div class="user-info">
                                                                        <div
                                                                            class="badge bg-outline-light rounded-pill ucap">
                                                                            {{ roller.ad }}</div>
                                                                        <h5> {{ roller.ad  }}</h5><span
                                                                            class="sub-text">{{ roller.ad }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-inner card-inner-sm">
                                                                <ul class="btn-toolbar justify-center gx-1">
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-shield-off"></em></a>
                                                                    </li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-mail"></em></a></li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-download-cloud"></em></a>
                                                                    </li>
                                                                   
                                                                    <li><a href="#"
                                                                            class="btn btn-trigger btn-icon text-danger"><em
                                                                                class="icon ni ni-na"></em></a></li>
                                                                </ul>
                                                            </div>
                                                        
                                                            <div class="card-inner">
                                                                <div class="row text-center">
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">roller</span><span
                                                                                class="sub-text">{{ roller.ad }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">roller</span><span
                                                                                class="sub-text">{{ roller.ad }}</span>
                                                                        
                                                                    </div>
                                                                  
                                                                </div>
                                                            </div>

                                           

                                                            <div class="card-inner">
                                                                <h6 class="overline-title-alt mb-2">Kayıt Bilgileri</h6>
                                                                <div class="row g-3">
                                                                    <div class="col-6"><span class="sub-text">Oluşturma Tarihi:</span><span>{{ roller.olusturma_tarih }}</span></div>
                                                                  
                                                                    <div class="col-6"><span class="sub-text">Son Düzenleme Tarihi:</span><span>{{ roller.duzenleme_tarih }}</span></div>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="simplebar-placeholder" style="width: auto; height: 815px;">
                                            </div>
                                        </div>
                                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                                        </div>
                                        <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="height: 0px; display: none;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>









            </AppMain>
        </div>
</template>
  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";

    
import kullaniciCard from "@/components/kullanicilar/kullaniciCard.vue";
import kullaniciForm from "@/components/kullanicilar/kullaniciForm.vue";



export default {
    name: "rollerDetayView",
    components: {
        AppMain,
            
        kullaniciCard, 
        kullaniciForm,
        
    },
    data() {
        return {
            roller: [],
           
            aktifSekme: 'kullanicilar',
            hareketSayfadaKayit: 10,
            hareketSeciliSayfa: 1,

            
            kullanicilar: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
          
            


        };
    },
    mounted() {
        this.ilkTabTanimla();
        this.rollerDetayGetir();
    },

    methods: {
        yetki_kontrol(yetki) {
            return yetkiKontrol(yetki);
        },
        ilkTabTanimla() {
            const tab = this.$route.params.tab;
                    if(tab=='bilgiler'){
                        this.aktifSekme = 'kullanicilar';
                        this.aktifSekmeDegistir("kullanicilar");
                    }else{
                        this.aktifSekme = tab;
                    }
                    
        },
        rollerDetayGetir() {
            const id = this.$route.params.id;

            axiosCustom
                .get(`roller/detay/${id}`)
                .then((response) => {
                    this.roller = response.data;
           
                    
                    this.kullanicilar.tumu = response.data.kullanicilar;
                    this.kullanicilar.modal = false;
                    

                    

                    
                })
                .catch((error) => {
                    console.error("Veri çekme hatası: ", error);
                });
        },

    
        aktifSekmeDegistir(sekme) {
            this.aktifSekme = sekme;
            const id = this.$route.params.id;
            this.$router.push('/roller/'+id+'/'+sekme);
        },




        
        kullanicilarGuncelle(veriler) {
            this.kullanicilar = veriler;
        },
        kullanicilar_ekle() {
            this.kullanicilar.secili = {'rol':this.roller.id};
            this.kullanicilar.islem = "ekle";
            this.kullanicilar.modal = true;
            this.aktifSekmeDegistir("kullanicilar");
        },
        kullanicilar_duzenle(veri) {
            this.kullanicilar.secili = veri;
            this.kullanicilar.islem = "duzenle";
            this.kullanicilar.modal = true;
        },
        kullanicilar_iptal() {
            this.kullanicilar.secili = {};
            this.kullanicilar.modal = false;
        },
        


       

        



    }
};
</script>
  

  